import { createContext, useContext, useState, ReactNode } from 'react';

interface GlobalFilterContextType {
  globalFilterTerm: string;
  setGlobalFilterTerm: (term: string) => void;
}

const GlobalFilterContext = createContext<GlobalFilterContextType | undefined>(undefined);

export const GlobalFilterProvider = ({ children }: { children: ReactNode }) => {
  const [globalFilterTerm, setGlobalFilterTerm] = useState("");

  return (
    <GlobalFilterContext.Provider value={{ globalFilterTerm, setGlobalFilterTerm }}>
      {children}
    </GlobalFilterContext.Provider>
  );
};

export const useGlobalFilter = () => {
  const context = useContext(GlobalFilterContext);
  if (context === undefined) {
    throw new Error('useGlobalFilter must be used within a GlobalFilterProvider');
  }
  return context;
};
